import axios from "axios";

const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: "/",
  defaultPath: "/dashboard",
  fontFamily: `'Inter', sans-serif`,
  borderRadius: 10,
};

const storedLgpath = localStorage.getItem("lgpath");

// export const baseUrl = "http://localhost:3008";
// export const homeUrl = "http://localhost:5173/";
// export const login = `http://localhost:5173/login?ur_d=${storedLgpath}`;
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? `http://localhost:5173/login?ur_d=${storedLgpath}`
//     : "http://localhost:5173/login?ur_d=";
// };

// ----------------------------PRODUCTION URLS ------------------------------

// export const baseUrl = "https://productionbackend.wizzo.in";
// export const homeUrl = " https://productioncloud.wizzo.in/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? ` https://productioncloud.wizzo.in/${storedLgpath}`
//     : `https://productioncloud.wizzo.in/`;
// };

// ----------------------------------------------------------
// ----------------------------RECKONTBS URLS ------------------------------

// export const baseUrl = "https://server.reckontbs.com";
// export const homeUrl = " https://cloud.reckontbs.com/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? ` https://cloud.reckontbs.com/${storedLgpath}`
//     : `https://cloud.reckontbs.com/`;
// };

// ----------------------------------------------------------
// ----------------------------saudi URLS ------------------------------

// export const baseUrl = "https://cloud-backend.wizzoit.com";
// export const homeUrl = " https://cloud.wizzoit.com/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? ` https://cloud.wizzoit.com${storedLgpath}`
//     : `https://cloud.wizzoit.com/`;
// };

// ----------------------------------------------------------

// -------------------- CLIENT SERVER URLS -------------------------

// export const baseUrl = "https://server.wizzo.in";
// export const homeUrl = "https://one.wizzo.in/";
// export const redirectUrl = storedLgpath
//   ? `https://one.wizzo.in${storedLgpath}`
//   : "https://one.wizzo.in/";
//   export const login = `https://one.wizzo.in/login?ur_d=${storedLgpath}`;

// ---------------------------------------------
// -------------------- UTHO SERVER URLS -------------------------

// export const baseUrl = "https://backend.utho.wizzo.in";
// export const homeUrl = "https://cloud.utho.wizzo.in/";
// export const login = `https://cloud.utho.wizzo.in/login?ur_d=${storedLgpath}`;
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? `https://cloud.utho.wizzo.in${storedLgpath}`
//     : "https://cloud.utho.wizzo.in/";
// };

// ---------------------------------------------
// -------------------- AZURE SERVER URLS -------------------------

// export const baseUrl = "https://cloud-backend.azure.wizzo.in";
// export const homeUrl = "https://cloud.azure.wizzo.in/";
// export const redirectUrl = storedLgpath
//   ? `https://cloud.azure.wizzo.in${storedLgpath}`
//   : "https://cloud.azure.wizzo.in/";
//   export const login = `https://cloud.azure.wizzo.in/login?ur_d=${storedLgpath}`;

// ---------------------------------------------
// -------------------- RECKON - AZURE URLS -------------------------

// export const baseUrl = "https://server.reckon.wizzo.in";
// export const homeUrl = "https://cloud.reckon.wizzo.in/";
// export const redirectUrl = storedLgpath
//   ? `https://cloud.reckon.wizzo.in${storedLgpath}`
//   : "https://cloud.reckon.wizzo.in/";
//   export const login = `https://cloud.reckon.wizzo.in/login?ur_d=${storedLgpath}`;

// ---------------------------------------------
// -------------------- PRODUCTION-RECKON URLS -------------------------

// export const baseUrl = "https://production.backend.reckontbs.com";
// export const homeUrl = " https://production.cloud.reckontbs.com/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? ` https://production.cloud.reckontbs.com/${storedLgpath}`
//     : `https://production.cloud.reckontbs.com/`;
// };

// ---------------------------------------------
// -------------------- AZURE-LIVE URLS -------------------------

// export const baseUrl = "https://backend.live.azure.wizzo.in";
// export const homeUrl = " https://cloud.live.azure.wizzo.in/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? ` https://cloud.live.azure.wizzo.in/${storedLgpath}`
//     : `https://cloud.live.azure.wizzo.in/`;
// };

// ---------------------------------------------

// -------------------- WIZZO-WPS URLS -------------------------

export const baseUrl = "https://backend.wps.wizzo.in";
export const homeUrl = " https://cloud.wps.wizzo.in/";
export const redirectUrl = () => {
  window.location.href = storedLgpath
    ? ` https://cloud.wps.wizzo.in/${storedLgpath}`
    : `https://cloud.wps.wizzo.in/`;
};

// ---------------------------------------------

// -------------------- WIZZO-WPS-PRODUCTION URLS -------------------------

// export const baseUrl = "https://backend.prod.wps.wizzo.in";
// export const homeUrl = " https://cloud.prod.wps.wizzo.in/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? ` https://cloud.prod.wps.wizzo.in/${storedLgpath}`
//     : `https://cloud.prod.wps.wizzo.in/`;
// };

// ---------------------------------------------

// export const baseUrl = "https://server.almaccloudpos.wizzosaudi.com";
// export const homeUrl = "https://almaccloudpos.wizzosaudi.com/";
// export const redirectUrl = () => {
//   window.location.href = storedLgpath
//     ? `https://almaccloudpos.wizzosaudi.com${storedLgpath}`
//     : "https://almaccloudpos.wizzosaudi.com/";
// };

// ---------------------------------------------

// export const baseUrl = 'https://integratedpos.wizzogroup.com/server';
// export const linkUrl = 'https://integratedpos.wizzogroup.com/login';
// export const baseUrl = 'https://almaccloudpos.wizzosaudi.com/server';
// export const linkUrl = 'https://almaccloudpos.wizzosaudi.com/login';
// export const baseUrl = "https://3.111.0.148:49205/server";
// export const linkUrl = "https://3.111.0.148:49203/login";

export const nonToken = () => {
  axios({
    method: "post",
    url: baseUrl + "/logout",
    withCredentials: true,
  })
    .then((res) => {
      window.location.href = "login";
    })
    .catch((err) => {
      if (err.response.status === 403 || err.response.status === 401)
        redirectUrl();
    });
};

export default config;
